import { useQuery } from "@tanstack/react-query";
import api from "../config/axiosConfig";

//Hook para cacheLoader
export const fetchDepartamentos = async () => {
  const response = await api.get("/departamentos");
  return response.data;
};

// Hook reutilizable con React Query
export const useDepartamentos = () => {
  return useQuery({
    queryKey: ["departamentos"],
    queryFn: fetchDepartamentos,
  });
};
